import React, { FC, useMemo, useContext, ReactNode } from 'react';

import { Icon } from '@src/atoms/Icon';
import { TITLE_DATA } from './const';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { IClassNameProps, IDefaultComponentProps, INotificationViewProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';

import styled from './Notification.module.scss';

interface IProps extends IClassNameProps, INotificationViewProps, IDefaultComponentProps {
  /**
   * Тип отображения (без/с заливкой цветом)
   */
  mode?: 'toast' | 'banner';

  /**
   * Содержимое нотификации (текст или компонент)
   */
  title?: string | ReactNode;

  /**
   * Скрывать ли крестик для закрытия
   */
  hideCloseBtn?: boolean;

  /**
   * Обработчик закрытия нотификации
   */
  onClose?: () => void;
}

/** Компонент уведомлений */
export const Notification: FC<IProps> = ({
  className,
  view = 'info',
  title: propsTitle,
  children,
  mode = 'toast',
  hideCloseBtn = false,
  style,
  onClose,
}) => {
  const { isMobile } = useContext(BreakpointsContext);
  const { color, icon, title } = useMemo(() => TITLE_DATA[view], [view]);

  const modeProperties = { [mode === 'banner' ? 'background' : 'border']: view };

  const classes = classnames(className, styled.root, ...getClasses(styled, { view, ...modeProperties, mode }), {
    [styled.rootMobile]: isMobile,
  });
  const titleClasses = classnames(...getClasses(styled, { title: color }));

  return (
    <div className={classes} style={style}>
      <div className={styled.rootContainer}>
        <Icon view={color} name={icon} size="md" />

        <div className={styled.rootText}>
          <div className={titleClasses} data-elem="not_title">
            {propsTitle || title}
          </div>

          {children}
        </div>
      </div>

      {!hideCloseBtn && <Icon name="close" size={13} className={styled.closeBtn} onClick={onClose} />}
    </div>
  );
};
